import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable()
export class Ng1TranslateService {
  private $translate: any;
  private angularMoment: any;
  private $users: any;

  constructor(private c: ConfigService) {}

  use(lang) {
    this.$translate = this.c.getValue('$translate');
    this.angularMoment = this.c.getValue('amMoment');
    this.angularMoment.changeLocale(lang);
    this.$translate.use(lang);
  }

  setLang(lang, keyValues, defaultLang) {
    this.c
      .getValue('$translateProvider')
      .translations(lang, keyValues)
      .registerAvailableLanguageKeys(['en', 'es'], {
        'en*': 'en',
        'es*': 'es',
        '*': defaultLang
      });
  }

  patchLang(transLang) {
    this.$users = this.c.getValue('Users');
    return this.$users.updateCurrent({}, transLang).$promise;
  }
}
